/**
 * Removes device-position query parameters from URLs that leave the page in a
 * Sentry event or breadcrumb. A search URL can carry a position.
 */
// Matches the key list in app/Service/Web/Views/blocks/ga.twig.
const POSITION_PARAMS = ["location", "lat", "lon", "lng"];

export function stripPositionParams(url) {
  if (typeof url !== "string" || url.indexOf("?") === -1) {
    return url;
  }
  try {
    const parsed = new URL(url, "https://www.interpals.net");
    const present = POSITION_PARAMS.filter((key) => parsed.searchParams.has(key));
    if (present.length === 0) {
      return url;
    }
    present.forEach((key) => parsed.searchParams.delete(key));
    const isAbsolute = /^[a-z][a-z0-9+.-]*:/i.test(url);
    return isAbsolute ? parsed.href : parsed.pathname + parsed.search + parsed.hash;
  } catch {
    return url.split("?")[0];
  }
}

export function scrubEventPosition(event) {
  if (event && event.request) {
    if (event.request.url) {
      event.request.url = stripPositionParams(event.request.url);
    }
    // The SDK copies the raw query string here as well as into the URL.
    delete event.request.query_string;
    if (event.request.headers && event.request.headers.Referer) {
      event.request.headers.Referer = stripPositionParams(event.request.headers.Referer);
    }
  }
  // A frame of an inline script names the page URL.
  const values = (event && event.exception && event.exception.values) || [];
  values.forEach((value) => {
    const frames = (value.stacktrace && value.stacktrace.frames) || [];
    frames.forEach((frame) => {
      frame.filename = stripPositionParams(frame.filename);
      frame.abs_path = stripPositionParams(frame.abs_path);
    });
  });
  return event;
}

export function scrubBreadcrumbPosition(breadcrumb) {
  const data = breadcrumb && breadcrumb.data;
  if (data) {
    ["url", "from", "to"].forEach((key) => {
      if (typeof data[key] === "string") {
        data[key] = stripPositionParams(data[key]);
      }
    });
  }
  return breadcrumb;
}
